import {
  IconButton,
  Menu,
} from '@mui/material';
import { useState } from 'react';
import { IoMdSettings } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { userLocalPreferencesKey, userLocalPreferencesSchema } from '../../../../constants';
import {
  setUserLocalPreferences,
} from '../../../../store/slices/userLocalPreferences';
import Checkbox from '../../../Checkbox';

const UserLocalPreferences = () => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const [anchorEl, setAnchorEl] = useState(null);

  const preferences = useSelector((store) => store?.[userLocalPreferencesKey]) || {};

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (key) => (event) => {
    const { checked } = event.target;
    dispatch(setUserLocalPreferences({ key, value: checked }));
    track('userLocalPreferencesChanged', { setting: key, value: checked });
  };

  return (
    <>
      <IconButton onClick={handleOpenMenu} size="small" style={{ color: 'var(--searchButtonColorHex)', outline: 'none' }}>
        <IoMdSettings size={20} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="px-4" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
          <div className="w-full text-sm text-gray-700" role="menuitem">
            {userLocalPreferencesSchema.map(({ key, label }) => (
              <div key={key} className="w-full text-sm text-gray-700" role="menuitem">
                <Checkbox
                  label={label}
                  checked={preferences?.[key] ?? false}
                  onChange={handleCheckboxChange(key)}
                />
              </div>
            ))}
          </div>
        </div>
      </Menu>
    </>
  );
};

export default UserLocalPreferences;
